<template>
  <div class="big doctorActivityStatistics">
    <div class="page_title flex_between">
      <span>{{pageTitle}}</span>
      <el-button type="primary"
                 style="width: 92px"
                 size="medium"
                 @click="back">返回</el-button>
    </div>

    <div style="padding: 20px; border-radius: 5px">
      <div class="container"
           style="padding: 10px 20px 20px 20px;">

        <div class="statistics-card">
          <!-- 开方金额 -->
          <el-card class="box-card">
            <div class="desc">
              <div class="value">
                <span class="val-1">￥{{countData.all_total_money}} </span>
                <span class="val-2">({{countData.all_total_money_no_settle}})</span>
                <span>
                  <el-popover placement="bottom"
                              trigger="hover"
                              content="总开方数量（待结算开方数量）">
                    <el-button slot="reference"
                               type="text"><i class="el-icon-question"></i></el-button>
                  </el-popover>
                </span>
              </div>
              <div class="title">开方金额</div>

            </div>
          </el-card>
          <!-- 药费金额 -->
          <el-card class="box-card">
            <div class="desc">
              <div class="value">
                <span class="val-1">￥{{countData.all_drug_money}} </span>
                <span class="val-2">({{countData.all_drug_money_no_settle}})</span>
                <span>
                  <el-popover placement="bottom"
                              trigger="hover"
                              content="已发放开方药费总额（待发放开方药费总额）">
                    <el-button slot="reference"
                               type="text"><i class="el-icon-question"></i></el-button>
                  </el-popover>
                </span>
              </div>
              <div class="title">药费金额</div>
            </div>
          </el-card>
          <!-- 仁心值奖励 -->
          <el-card class="box-card">
            <div class="desc">
              <div class="value">
                <span class="val-1">￥{{countData.all_heart_multiple}} </span>
                <span class="val-2">({{routeQuery.month_heart_multiple}})</span>
                <span>
                  <el-popover placement="bottom"
                              trigger="hover"
                              content="已奖励仁心值数量（预计奖励数量）">
                    <el-button slot="reference"
                               type="text"><i class="el-icon-question"></i></el-button>
                  </el-popover>
                </span>
              </div>
              <div class="title">仁心值奖励</div>
            </div>
          </el-card>
        </div>

        <div class="page_title"
             style="padding:0;background:#fff">活动奖励详情</div>
        <div class="reward-detail">
          <template v-if="detailsData.length">
            <el-card class="box-card"
                     v-for="(item,index) in detailsData"
                     :key="index">
              <div slot="header"
                   class="header-box">
                <span>{{ item.title }}</span>
                <el-tag :type="item.status == '达标' ? 'success' : 'danger'">{{item.status}}</el-tag>
              </div>

              <div v-if="item.status != '达标'">
                该医生当月暂未达到奖励门槛
              </div>
              <div v-else
                   class="content-box">
                <div class="item">
                  <span>奖励名称:&nbsp;</span>
                  <span>{{ item.rule_name }}</span>
                </div>

                <div class="item">
                  <span>奖励条件:&nbsp;</span>
                  <span>{{ item.reward_condition }}</span>
                </div>

                <div class="item">
                  <span>奖励类型:&nbsp;</span>
                  <span>{{ item.reward_type }}</span>
                </div>

                <div class="item">
                  <span>首次进阶奖励:&nbsp;</span>
                  <span>{{ item.first_reward }}</span>
                </div>

                <div class="item">
                  <span>奖励详情:&nbsp;</span>
                  <span>{{ item.reward_detail }}</span>
                </div>

                <div class="item">
                  <span>进阶奖励:&nbsp;</span>
                  <span>{{ item.remark }}</span>
                </div>
              </div>
            </el-card>
          </template>

          <div v-else
               style="padding-top:20px">该医生暂无奖励数据</div>
        </div>

      </div>
    </div>
  </div>

</template>

<script>
import _ from 'lodash';
import dayjs from 'dayjs';
import marketing from '@/api/marketing.js';
export default {
  data() {
    return {
      pageTitle: '',
      countData: {},
      detailsData: []
    };
  },
  filters: {
    dateFormat(val) {
      return !val ? '' : dayjs.unix(val).format('YYYY-MM-DD HH:mm');
    }
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    routeQuery() {
      return this.$route.query;
    }
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      let { act_id, doctor_id } = this.routeQuery;
      let params = {
        act_id,
        doctor_id
      };
      const loading = this.$loading();
      marketing
        .doctorHeartActivityCountDetail(params)
        .then((res) => {
          let { code, data } = res;
          if (code == 0) {
            this.pageTitle = data.title;
            this.countData = data.count_data;
            this.detailsData = data.detail;
          }
          loading.close();
        })
        .catch((err) => {
          loading.close();
        });
    },
    back() {
      history.back();
    }
  }
};
</script>

<style lang="scss" scoped >
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.doctorActivityStatistics {
  .statistics-card {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    .box-card {
      width: 30%;
      ::v-deep .el-card__body {
        display: flex;
        align-items: center;
        justify-content: space-around;
        .desc {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          .value {
            font-size: 20px;
            font-weight: bold;
            .val-1 {
              color: #669961;
            }
            .val-2 {
              font-size: 16px;
              font-weight: normal;
            }
          }
          .title {
            padding: 10px 0;
          }
        }
      }
    }
  }
  .reward-detail {
    .box-card {
      width: 600px;
      margin-bottom: 10px;
      .header-box {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .content-box {
        .item {
          display: flex;
          align-items: center;
          margin-bottom: 10px;
        }
      }
    }
  }
}
</style>